import { StyledPrismicRichText } from "@/components/StyledPrismicRichText";
import { PrismicNextImage } from "@prismicio/next";

export default function ItemCard({ data }) {
  return (
    <div className="py-[20px] sm:px-[20px] xl:p-[30px] sm:border-b-[0.5px] sm:last:border-b-0 sm:odd:border-r-[0.5px] sm:border-[#C5C5C5]">
      {data.icon?.url && (
        <PrismicNextImage
          className="w-[50px] h-[50px] sm:w-[40px] sm:h-[40px] mb-[14px]"
          field={data.icon}
          fallbackAlt=""
        />
      )}
      <div className="title-font title-medium mb-[12px]">
        <StyledPrismicRichText field={data?.title} />
      </div>
      <div className="text-base">
        <StyledPrismicRichText field={data?.text} />
      </div>
    </div>
  );
}
